import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { StyledLegalDocumentContainer } from '@/components/blocks/Document/LegalDocument.Styled'
import Layout from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

import content from '../../public/assets/markdown/privacy-policy-e.md'

const PrivacyPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: t('landing_privacy_policy') + ' | Fitify',
        description: t('landing_privacy_policy_meta_description'),
      }}
    >
      <MarkdownContentRenderer
        content={content}
        contentWrapper={StyledLegalDocumentContainer}
      />
    </Layout>
  )
}

export default PrivacyPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
